"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./../store/store"));

var AnnouncementActions = _interopRequireWildcard(require("./../store/actions/actions"));

var NotificationSelectors = _interopRequireWildcard(require("./../store/reducers/NotificationReducer"));

var types = _interopRequireWildcard(require("./../store/actions/actionTypes"));

var _SettingsService = _interopRequireDefault(require("./../service/SettingsService"));

var _GraphqlService = require("./../service/GraphqlService");

var _AnnouncementReducer = require("./../store/reducers/AnnouncementReducer");

var _PulseUtil = _interopRequireDefault(require("./../util/PulseUtil"));

var _AppAssemblyResponseParser = require("./../service/AppAssemblyResponseParser");

var _NotificationsPollService = require("./../service/NotificationsPollService");

var _AnnouncementLongPoll = require("./../service/AnnouncementLongPoll");

var _TimelineService = _interopRequireDefault(require("./../service/TimelineService"));

var _metrics = _interopRequireDefault(require("./../custom-hooks/metrics"));

var _withRedux = _interopRequireDefault(require("../components/commons/withRedux"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Constants = require("../constants/Constants");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var mapStateToProps = function mapStateToProps(state) {
  return {
    newNotificationsCount: (0, NotificationSelectors.isFlyoutOpen)(state) && (0, NotificationSelectors.getActiveTabIndex)(state) == 0 ? 0 : (0, NotificationSelectors.getNewNotifications)(state).length,
    isUnseenAnnouncements: (0, _AnnouncementReducer.hasUnseenAnnouncements)(state),
    serverTimeStamp: (0, NotificationSelectors.getServerTimestamp)(state),
    clientTimeStamp: (0, NotificationSelectors.getClientTimestamp)(state),
    activeTabIndex: (0, NotificationSelectors.getActiveTabIndex)(state),
    activeImsOrg: (0, NotificationSelectors.getActiveIMSOrg)(state)
  };
};

var notificationPoller, announcementPoller;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchToChangeActiveIndex: function dispatchToChangeActiveIndex(tabIndex) {
      dispatch({
        type: types.ACTIVE_TAB_INDEX_CHANGED,
        payload: tabIndex
      });
    },
    dispatchToSetLastNotificationSeenTimestamp: function dispatchToSetLastNotificationSeenTimestamp(timestamp) {
      dispatch({
        type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
        payload: timestamp
      });
    },
    dispatchToSetFlyoutLastOpenTimeStamp: function dispatchToSetFlyoutLastOpenTimeStamp(timestamp) {
      dispatch({
        type: types.SET_FLYOUT_LAST_OPEN_TIMESTAMP,
        payload: timestamp
      });
    },
    dispatchToSetFlyoutLastCloseTimeStamp: function dispatchToSetFlyoutLastCloseTimeStamp(timestamp) {
      dispatch({
        type: types.SET_FLYOUT_LAST_CLOSE_TIMESTAMP,
        payload: timestamp
      });
    },
    dispatchToFetchUserEntitlements: function dispatchToFetchUserEntitlements(payload) {
      dispatch({
        type: types.FETCHED_USER_ENTITLEMENTS,
        userEntitlementsPayload: payload
      });
    },
    dispatchToFetchNotificationConfig: function () {
      var _dispatchToFetchNotificationConfig = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(payload) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch({
                  type: types.NOTIFICATIONS_CONFIG_FETCHED,
                  payload: payload
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function dispatchToFetchNotificationConfig(_x) {
        return _dispatchToFetchNotificationConfig.apply(this, arguments);
      }

      return dispatchToFetchNotificationConfig;
    }(),
    dispatchToSetLastUserClickTimestamp: function dispatchToSetLastUserClickTimestamp(timestamp) {
      dispatch({
        type: types.SET_LAST_USER_CLICK_TIMESTAMP,
        payload: timestamp
      });
    },
    dispatchToSetDisplayAlerts: function dispatchToSetDisplayAlerts(payload) {
      dispatch({
        type: types.DISPLAY_ALERTS_FETCHED,
        payload: payload
      });
    },
    dispatchToSetLastAnnouncementTimestamp: function dispatchToSetLastAnnouncementTimestamp(timestamp) {
      dispatch({
        type: types.SET_LAST_ANNOUNCEMENT_TS,
        payload: {
          lastSeenTimestamp: timestamp
        }
      });
    },
    dispatchToSetActiveImsOrg: function dispatchToSetActiveImsOrg(payload) {
      dispatch({
        type: types.ACTIVE_IMS_ORG_CHANGED,
        payload: payload
      });
    }
  };
};
/**
 * TODO: Metrics Timing API needs to be confirmed.
 */


var PulseContainer = function PulseContainer(props) {
  var accessToken = props.accessToken,
      locale = props.locale,
      _props$opened = props.opened,
      opened = _props$opened === void 0 ? false : _props$opened,
      activeTabIndex = props.activeTabIndex,
      serverTimeStamp = props.serverTimeStamp,
      clientTimeStamp = props.clientTimeStamp,
      appId = props.appId,
      children = props.children,
      settingsService = props.settingsService,
      shellResponse = props.shellResponse,
      newNotificationsCount = props.newNotificationsCount,
      isUnseenAnnouncements = props.isUnseenAnnouncements,
      profile = props.profile,
      dispatchToChangeActiveIndex = props.dispatchToChangeActiveIndex,
      dispatchToSetLastNotificationSeenTimestamp = props.dispatchToSetLastNotificationSeenTimestamp,
      dispatchToSetFlyoutLastOpenTimeStamp = props.dispatchToSetFlyoutLastOpenTimeStamp,
      dispatchToSetFlyoutLastCloseTimeStamp = props.dispatchToSetFlyoutLastCloseTimeStamp,
      dispatchToFetchUserEntitlements = props.dispatchToFetchUserEntitlements,
      selectedImsOrg = props.selectedImsOrg,
      environment = props.environment,
      dispatchToFetchNotificationConfig = props.dispatchToFetchNotificationConfig,
      dispatchToSetLastUserClickTimestamp = props.dispatchToSetLastUserClickTimestamp,
      dispatchToSetLastAnnouncementTimestamp = props.dispatchToSetLastAnnouncementTimestamp,
      settingsResponse = props.settingsResponse,
      timelineResponse = props.timelineResponse,
      userOrgPreferences = props.userOrgPreferences,
      activeImsOrg = props.activeImsOrg,
      dispatchToSetActiveImsOrg = props.dispatchToSetActiveImsOrg,
      onUnreadChange = props.onUnreadChange,
      dispatchToSetDisplayAlerts = props.dispatchToSetDisplayAlerts;
  var isFirstRun = (0, _react.useRef)(true);
  var isFirstOpen = (0, _react.useRef)(true);
  var metrics = (0, _metrics.default)('exc.pulse.PulseContainer'); // const timer= metrics.start() //TODO: Need to check the correct usage for timer API.

  /**
   * It will intitialize Pulse Services.
   */

  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      isFirstRun.current = false; // eslint-disable-next-line @typescript-eslint/no-use-before-define

      initialize(settingsResponse, timelineResponse, userOrgPreferences);
      return;
    }
  }, []);
  /**
   * It will handle the case when
   * User ORG get changed.
   */

  (0, _react.useEffect)(function () {
    if (!isFirstRun.current && activeImsOrg && activeImsOrg !== selectedImsOrg) {
      dispatchToSetActiveImsOrg(selectedImsOrg);
      /** Get alerts preferences data from graphql */

      var fetchGraphqlData =
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee2() {
          var response;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return (0, _GraphqlService.postGQL)({
                    imsOrgId: selectedImsOrg,
                    imsUserId: profile.userId
                  });

                case 2:
                  response = _context2.sent;
                  //TODO the first 2 params accept Settings and Timeline response default to empty object

                  /*eslint-disable-next-line @typescript-eslint/no-use-before-define*/
                  initialize({}, {}, response && response.data.userOrgPreferences);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function fetchGraphqlData() {
          return _ref.apply(this, arguments);
        };
      }();

      fetchGraphqlData();
    }
  }, [selectedImsOrg]);
  /**
   * It will handle the case where the flyout
   * popover get open/closed.
   */

  (0, _react.useEffect)(function () {
    if (isFirstOpen.current) {
      isFirstOpen.current = false;
      return;
    }

    if (opened) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      onFlyoutOpen();
    } else {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      onFlyoutClose();
    }
  }, [opened]);
  /**
   * When unread notifications and announcements are generated
   * Count and Badge needs to be shown in the header.
   */

  (0, _react.useEffect)(function () {
    onUnreadChange(newNotificationsCount, isUnseenAnnouncements);
  }, [isUnseenAnnouncements, newNotificationsCount]);
  /**
   * It will fetch User Entitlements from shell response.
   */

  var fetchUserEntitlements = function fetchUserEntitlements() {
    var userEntitlementsPayload = (0, _AppAssemblyResponseParser.getUserEntitlementsFromAppAssemblyResponse)(shellResponse);
    dispatchToFetchUserEntitlements(userEntitlementsPayload);
  };
  /**
   * This method will initialize shell service.
   * 1. Will configure settingsService with pre-fetched data
   * 2. Will fetch notification configs for category filters etc.
   * 3. Will update user settings with relevant time stamps.
   * 4. Will fetch timeline data if required. In the initial load it will pass timeline data fetched from graphql.
   * 5. Will start polling for new notifications and announcements.
   *
   * @param settingsResponse
   * @param timelineResponse
   */


  var initialize =
  /*#__PURE__*/
  function () {
    var _ref2 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee3() {
      var settingsResponse,
          timelineResponse,
          userOrgPreferences,
          notificationConfigPayload,
          displayAlert,
          _args3 = arguments;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              settingsResponse = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              timelineResponse = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              userOrgPreferences = _args3.length > 2 ? _args3[2] : undefined;

              if (!_SettingsService.default.service) {
                _SettingsService.default.configure({
                  settingsService: settingsService,
                  viewAll: false
                });
              }

              fetchUserEntitlements();
              notificationConfigPayload = {
                accessToken: accessToken,
                activeIMSOrg: selectedImsOrg,
                locale: locale,
                environment: environment
              };
              /**
               * set display Alert to default values if preferences have empty settings value
               * handling the null value for userOrgPreferences and updating the store with default configuration
               */

              displayAlert = (0, _isEmpty.default)(userOrgPreferences && userOrgPreferences.displayAlert) ? _Constants.DEFAULT_DISPLAY_ALERTS : userOrgPreferences.displayAlert;
              _context3.next = 9;
              return dispatchToSetDisplayAlerts(displayAlert);

            case 9:
              _context3.next = 11;
              return dispatchToFetchNotificationConfig(notificationConfigPayload);

            case 11:
              // eslint-disable-next-line @typescript-eslint/no-use-before-define
              updateUserSettings(settingsResponse);

              _TimelineService.default.fetchTimeline(_store.default, {}, timelineResponse);

              notificationPoller = (0, _NotificationsPollService.fetchNotificationsData)(_store.default);
              notificationPoller.start();
              _context3.next = 17;
              return (0, _AnnouncementLongPoll.fetchAnnouncementsData)(_store.default);

            case 17:
              announcementPoller = _context3.sent;
              announcementPoller.start(); // timer.time('exc.pulse.initiated');

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function initialize() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * It will update user settings for relevant time stamps.
   *
   * @param settingsData
   */


  var updateUserSettings =
  /*#__PURE__*/
  function () {
    var _ref3 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee4() {
      var settingsData,
          userSettings,
          _args4 = arguments;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              settingsData = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _context4.next = 3;
              return _SettingsService.default.getUserSettings(settingsData);

            case 3:
              userSettings = _context4.sent;

              if (userSettings) {
                if ('lastClickTimestamp' in userSettings) {
                  dispatchToSetLastUserClickTimestamp(userSettings.lastClickTimestamp);
                }

                if ('lastSeenAnnouncementsTimestamp' in userSettings) {
                  dispatchToSetLastAnnouncementTimestamp(userSettings.lastSeenAnnouncementsTimestamp);
                }

                if ('lastNotificationSeenTimestamp' in userSettings) {
                  dispatchToSetLastNotificationSeenTimestamp(userSettings.lastNotificationSeenTimestamp);
                }
              }

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function updateUserSettings() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * It will handle which tab to be opened when notification bell icon is clicked.
   * 1. If new notifications and announcements, open the previously selected tab.
   * 2. If new notifications, open notifications tab.
   * 3. If new announcements, open announcements tab.
   * 4. Else, open previously selected tab.
   */


  var openDefaultTab =
  /*#__PURE__*/
  function () {
    var _ref4 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee5() {
      var tabIndex;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              tabIndex = 0;

              if (newNotificationsCount > 0 && isUnseenAnnouncements) {
                tabIndex = activeTabIndex === 0 ? 0 : 1;
              } else if (newNotificationsCount > 0) {
                tabIndex = 0;
              } else if (isUnseenAnnouncements) {
                tabIndex = 1;
              } else {
                tabIndex = activeTabIndex;
              }

              _context5.next = 4;
              return dispatchToChangeActiveIndex(tabIndex);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function openDefaultTab() {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * It will set the timestamp when last notifications have been seen.
   *
   * @param timeStampVal
   */


  var setLastNotificationSeen =
  /*#__PURE__*/
  function () {
    var _ref5 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee6() {
      var timeStampVal,
          userSettings,
          _args6 = arguments;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              timeStampVal = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;

              if (!timeStampVal) {
                _context6.next = 6;
                break;
              }

              _context6.next = 4;
              return dispatchToSetLastNotificationSeenTimestamp(timeStampVal);

            case 4:
              _context6.next = 13;
              break;

            case 6:
              _context6.next = 8;
              return _SettingsService.default.getUserSettings();

            case 8:
              userSettings = _context6.sent;
              _context6.t0 = userSettings && userSettings.lastClickTimestamp;

              if (!_context6.t0) {
                _context6.next = 13;
                break;
              }

              _context6.next = 13;
              return dispatchToSetLastNotificationSeenTimestamp(userSettings.lastClickTimestamp);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function setLastNotificationSeen() {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * It will handle when notifications popover is opened.
   */


  var onFlyoutOpen =
  /*#__PURE__*/
  function () {
    var _ref6 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee7() {
      var timeNow;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              openDefaultTab();
              metrics.event('flyout.open', {
                region: window.config && window.config.region,
                solution: appId
              });
              AnnouncementActions.onAnnouncementTabMount(false);
              timeNow = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
              setLastNotificationSeen();
              _context7.next = 7;
              return dispatchToSetLastUserClickTimestamp(timeNow);

            case 7:
              _context7.next = 9;
              return dispatchToSetFlyoutLastOpenTimeStamp(timeNow);

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function onFlyoutOpen() {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * It will handle when the popover get closed.
   */


  var onFlyoutClose =
  /*#__PURE__*/
  function () {
    var _ref7 = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee8() {
      var activeTabIndex, timeNow;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              metrics.event('flyout.close', {
                region: window.config && window.config.region
              });
              activeTabIndex = NotificationSelectors.getActiveTabIndex(_store.default.getState());

              if (activeTabIndex === 1) {
                AnnouncementActions.onAnnouncementTabUnmount();
              }

              timeNow = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
              setLastNotificationSeen(timeNow);
              _context8.next = 7;
              return dispatchToSetLastUserClickTimestamp(timeNow);

            case 7:
              _context8.next = 9;
              return dispatchToSetFlyoutLastCloseTimeStamp(timeNow);

            case 9:
              _context8.next = 11;
              return _SettingsService.default.updateUserSettings({
                lastClickTimestamp: timeNow,
                lastNotificationSeenTimestamp: timeNow
              });

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function onFlyoutClose() {
      return _ref7.apply(this, arguments);
    };
  }();

  return _react.default.createElement(_react.default.Fragment, null, children);
};

document.addEventListener('visibilitychange', function () {
  _PulseUtil.default.onVisibilityChange(notificationPoller, announcementPoller);
}, false);

var _default = (0, _withRedux.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PulseContainer));

exports.default = _default;